import React from 'react';
import CabinetTable from './cabinetTable';

const UnapprovedCabinet = () => {
    return (
        <>
            <CabinetTable tab='unapproved' />
        </>
    );
};

export default UnapprovedCabinet;